import { render, staticRenderFns } from "./ReviewGlossesView.vue?vue&type=template&id=8a1cd094&scoped=true"
import script from "./ReviewGlossesView.vue?vue&type=script&lang=js"
export * from "./ReviewGlossesView.vue?vue&type=script&lang=js"
import style0 from "./ReviewGlossesView.vue?vue&type=style&index=0&id=8a1cd094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1cd094",
  null
  
)

export default component.exports